// utils/authFunctions.js
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useLoading } from '../contexts/LoadingContext';   // Updated to useLoading from LoadingContext
import { useAuth } from '../contexts/AuthContext';         // Updated to useAuth from AuthContext

/**
 * Hook that returns an async `logout` function.
 * 1. Sets a global loading flag (`authFunctions`).
 * 2. Calls Firebase `signOut()`.
 * 3. Dispatches RESET_USER to AuthContext.
 * 4. **Clears the loading flag BEFORE redirecting** so the Login page
 *    never mounts with `isLoading === true`.
 */
export const useLogout = () => {
  const navigate         = useNavigate();
  const { setLoading }   = useLoading(); // Updated to useLoading
  const { dispatch }     = useAuth();    // Updated to useAuth

  const logout = async () => {
    console.log('[useLogout] Starting logout flow');
    setLoading(true, 'authFunctions');   // mark global loader

    try {
      await auth.signOut();              // Firebase sign-out
      console.log('[useLogout] Firebase signOut() resolved');

      // Reset the user state in AuthContext
      dispatch({ type: 'RESET_USER' });
      console.log('[useLogout] Dispatched RESET_USER');
    } catch (error) {
      console.error('[useLogout] Logout failed:', error);
      // Optionally: show an error toast/snackbar here
    } finally {
      // ─────────────────────────────────────────────────────────────
      // CLEAR LOADING FIRST → then redirect
      // ─────────────────────────────────────────────────────────────
      setLoading(false, 'authFunctions');
      console.log('[useLogout] Cleared loading flag — navigating to /login');
      setLoading(false, 'Auth');           
      // Use replace:true so the user can’t hit “Back” into a protected page
      navigate('/login', { replace: true });
    }
  };

  return logout;
};
